'use strict';

import { Injectable, inject  } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OktaAuthStateService, OKTA_AUTH } from '@okta/okta-angular'; // Updated import
// ApiGatewayAccessToken removed - using direct Okta Bearer tokens
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  authenticationState$: Observable<boolean>;

  private oktaStateService = inject(OktaAuthStateService);
  private oktaAuth = inject(OKTA_AUTH); // This should be OktaAuth

  constructor(
    private http: HttpClient,
  ) {
    this.authenticationState$ = this.oktaStateService.authState$.pipe(
      filter((s) => !!s),
      map((s) => s.isAuthenticated ?? false)
    );
  }

  isAuthenticated(): Promise<boolean> {
    return this.oktaAuth.isAuthenticated();
  }

  getUserInfo() {
    return this.oktaAuth.getUser();
  }

  getUserAccessToken(): string {
    return this.oktaAuth.getAccessToken();
  }

  async ensureIdTokenHasNotExpired() {
    const idToken: any = await this.oktaAuth.tokenManager.get('idToken');
    const validationOptions = {
      issuer: environment.okta.issuer
    }
    return this.oktaAuth.token.verify(idToken, validationOptions);
  }

  async logError(errorObj: HttpErrorResponse): Promise<void> {
    const userAccessToken = this.oktaAuth.getAccessToken();
    const errorBody = {
      level: 'error',
      msg: `${errorObj.url} failed with error code: ${errorObj.status} having message: ${errorObj.message}`
    };
    await this.http.post<void>(environment.uiServerUrl + '/log', errorBody, {
      headers: {
        Authorization: 'Bearer ' + userAccessToken,
      }
    }).toPromise()
      .catch(err => console.error(err));
  }

  async logout(uri?: string): Promise<void> {
    const userAccessToken = this.oktaAuth.getAccessToken();
    await this.http.post<void>(environment.uiServerUrl + '/logout', '', {
      headers: {
        Authorization: 'Bearer ' + userAccessToken,
      }
    }).toPromise()
      .catch(err => console.error(err));
    // return this.oktaAuth.signOut(uri);
    // this.oktaAuth.signOut(uri);
    this.oktaAuth.signOut(); // Ensure you're using the correct service
  }
}
